import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MTagComponent } from '../m-tag/m-tag.component';
import { PercentPipe } from '@angular/common';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'm-metric-amount-header',
  templateUrl: './m-metric-amount-header.component.html',
  styleUrls: ['./m-metric-amount-header.component.scss'],
  imports: [MTagComponent, PercentPipe]
})
export class MMetricAmountHeaderComponent {
  @Input() title = '';
  @Input() amount = '';
  @Input() prevPercDifference = 0;
  @Input() prevPercDifferenceFormattedValue: string | null = null;
  @Input() isPositive = false;
  @Input() isNeutral = false;
  @Input() isUp = false;
}
